<div class="wizard-wrapper glass-wizard" [class.keyboard-active]="isKeyboardActive">

  <!-- ── HEADER DEL WIZARD ───────────────────────────────────────────── -->
  <div class="wizard-header">
    <button class="wiz-back-btn" (click)="dismiss()" aria-label="Cerrar">
      <ion-icon name="close"></ion-icon>
    </button>

    <!-- Barra de progreso visual -->
    <div class="progress-track">
      <div class="progress-fill" [style.width.%]="(currentStep / totalSteps) * 100"></div>
    </div>

    <span class="step-counter">{{ currentStep }}/{{ totalSteps }}</span>
  </div>

  <!-- ── CONTENIDO POR PASO ─────────────────────────────────────────── -->
  <ion-content class="wizard-content">
    <div class="wizard-body">

      <!-- ══════════ PASO 1 — SOLICITANTE ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 1">
        <div class="step-header">
          <div class="step-illustration solicitante">
            <ion-icon name="person-circle"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">¿Quién solicita la inspección?</h2>
            <p class="step-hint">Persona que está pidiendo el trabajo</p>
          </div>
        </div>

        <!-- Solicitantes Frecuentes (filtrados por cliente si está definido) -->
        <div class="frequent-section" *ngIf="getTopSolicitantesDisponibles().length > 0 && !selectedSolicitanteId">
          <div class="freq-title">
            <ion-icon name="sparkles-outline"></ion-icon>
            <span>Frecuentes (Top 10)</span>
          </div>
          <div class="freq-chips">
            <div class="freq-chip" *ngFor="let top of getTopSolicitantesDisponibles()" (click)="selectTopSolicitante(top.nombre)">
              <div class="freq-avatar">{{ top.nombre.charAt(0) }}</div>
              <span>{{ top.nombre }}</span>
            </div>
          </div>
        </div>

        <div class="step-input-area">
          <!-- Estado 1: Sin selección previa -> Toca para seleccionar -->
          <div class="big-input-box" *ngIf="!selectedSolicitanteId" (click)="openGenericSelector('SOLICITANTE', 'Seleccionar Solicitante', 'Buscar solicitante...', getSolicitantesDisponibles())">
            <ion-icon name="person-outline" class="bi-search"></ion-icon>
            <div class="big-input">
              <span class="placeholder-text">Toca para seleccionar solicitante...</span>
            </div>
            <ion-icon name="chevron-forward-outline" class="bi-chevron"></ion-icon>
          </div>

          <!-- Estado 2: Con selección -> Tarjeta interactiva única (toca para cambiar) -->
          <div class="interactive-selection-card" *ngIf="selectedSolicitanteId" (click)="openGenericSelector('SOLICITANTE', 'Seleccionar Solicitante', 'Buscar solicitante...', getSolicitantesDisponibles())">
            <div class="isc-top-row">
              <div class="isc-header-group">
                <div class="isc-avatar">
                  <span>{{ formData.solicitante.charAt(0) }}</span>
                </div>
                <div class="isc-meta">
                  <span class="isc-category">Solicitante Confirmado</span>
                  <span class="isc-count-badge">{{ formData.solicitante }}</span>
                </div>
              </div>
              <ion-icon name="chevron-forward-outline" class="isc-arrow-icon"></ion-icon>
            </div>
            <span class="isc-hint">
              <ion-icon name="options-outline"></ion-icon>
              Toca para cambiar o seleccionar otro solicitante
            </span>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 2 — CLIENTE ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 2">
        <!-- Contexto del Solicitante Seleccionado -->
        <div class="wizard-location-context" *ngIf="formData.solicitante">
          <div class="wlc-icon-wrap">
            <ion-icon name="person"></ion-icon>
          </div>
          <div class="wlc-text">
            <span class="wlc-label">Solicitado por:</span>
            <span class="wlc-name">{{ formData.solicitante }}</span>
          </div>
        </div>

        <div class="step-header">
          <div class="step-illustration cliente">
            <ion-icon name="business"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">¿Para qué cliente es?</h2>
            <p class="step-hint">Responsable o empresa contratante</p>
          </div>
        </div>

        <!-- Clientes asignados al solicitante -->
        <div class="frequent-section" *ngIf="clientesFiltradosPorSolicitante.length > 1 && !selectedClienteId">
          <div class="freq-title">
            <ion-icon name="sparkles-outline"></ion-icon>
            <span>Clientes de {{ formData.solicitante }}</span>
          </div>
          <div class="freq-chips">
            <div class="freq-chip" *ngFor="let c of clientesFiltradosPorSolicitante" (click)="selectCliente(c)">
              <div class="freq-avatar biz">{{ c.nombre.charAt(0) }}</div>
              <span>{{ c.nombre }}</span>
            </div>
          </div>
        </div>

        <div class="step-input-area">
          <!-- Estado 1: Sin selección previa -> Toca para seleccionar -->
          <div class="big-input-box" *ngIf="!selectedClienteId" (click)="openGenericSelector('CLIENTE', 'Seleccionar Cliente', 'Buscar cliente o empresa...', getClientesDisponibles())">
            <ion-icon name="business-outline" class="bi-search"></ion-icon>
            <div class="big-input">
              <span class="placeholder-text">Toca para seleccionar cliente...</span>
            </div>
            <ion-icon name="chevron-forward-outline" class="bi-chevron"></ion-icon>
          </div>

          <!-- Estado 2: Con selección -> Tarjeta interactiva única (toca para cambiar) -->
          <div class="interactive-selection-card" *ngIf="selectedClienteId" (click)="openGenericSelector('CLIENTE', 'Seleccionar Cliente', 'Buscar cliente o empresa...', getClientesDisponibles())">
            <div class="isc-top-row">
              <div class="isc-header-group">
                <div class="isc-avatar biz">
                  <span>{{ formData.cliente.charAt(0) }}</span>
                </div>
                <div class="isc-meta">
                  <span class="isc-category">Cliente Confirmado</span>
                  <span class="isc-count-badge">{{ formData.cliente }}</span>
                </div>
              </div>
              <ion-icon name="chevron-forward-outline" class="isc-arrow-icon"></ion-icon>
            </div>
            <span class="isc-hint">
              <ion-icon name="options-outline"></ion-icon>
              Toca para cambiar o seleccionar otro cliente
            </span>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 3 — DIRECCIÓN ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 3">
        <!-- Contexto del Solicitante Seleccionado -->
        <div class="wizard-location-context" *ngIf="formData.solicitante">
          <div class="wlc-icon-wrap">
            <ion-icon name="person"></ion-icon>
          </div>
          <div class="wlc-text">
            <span class="wlc-label">Solicitado por:</span>
            <span class="wlc-name">{{ formData.solicitante }}</span>
          </div>
        </div>

        <div class="step-header">
          <div class="step-illustration location">
            <ion-icon name="location"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">¿Dónde se realizará?</h2>
            <p class="step-hint">Dirección o lugar del trabajo</p>
          </div>
        </div>

        <!-- Direcciones Frecuentes -->
        <div class="frequent-section" *ngIf="topDirecciones.length > 0 && !selectedDireccionId">
          <div class="freq-title">
            <ion-icon name="sparkles-outline"></ion-icon>
            <span>Direcciones Frecuentes (Top 10)</span>
          </div>
          <div class="freq-chips">
            <div class="freq-chip" *ngFor="let top of topDirecciones" (click)="selectTopDireccion(top.nombre)">
              <div class="freq-avatar loc"><ion-icon name="pin"></ion-icon></div>
              <span>{{ top.nombre }}</span>
            </div>
          </div>
        </div>

        <div class="step-input-area">
          <!-- Estado 1: Sin selección previa -> Toca para seleccionar -->
          <div class="big-input-box" *ngIf="!selectedDireccionId" (click)="openGenericSelector('DIRECCION', 'Seleccionar Dirección', 'Buscar dirección...', direccionesList, { clienteId: selectedClienteId })">
            <ion-icon name="location-outline" class="bi-search"></ion-icon>
            <div class="big-input">
              <span class="placeholder-text">Toca para seleccionar dirección...</span>
            </div>
            <ion-icon name="chevron-forward-outline" class="bi-chevron"></ion-icon>
          </div>

          <!-- Estado 2: Con selección -> Tarjeta interactiva única (toca para cambiar) -->
          <div class="interactive-selection-card" *ngIf="selectedDireccionId" (click)="openGenericSelector('DIRECCION', 'Seleccionar Dirección', 'Buscar dirección...', direccionesList, { clienteId: selectedClienteId })">
            <div class="isc-top-row">
              <div class="isc-header-group">
                <div class="isc-avatar loc">
                  <ion-icon name="pin"></ion-icon>
                </div>
                <div class="isc-meta">
                  <span class="isc-category">Lugar Confirmado</span>
                  <span class="isc-count-badge">{{ formData.direccion }}</span>
                </div>
              </div>
              <ion-icon name="chevron-forward-outline" class="isc-arrow-icon"></ion-icon>
            </div>
            <span class="isc-hint">
              <ion-icon name="options-outline"></ion-icon>
              Toca para cambiar o seleccionar otra dirección
            </span>
          </div>
        </div>
      </div>

      <!-- ══════════ PASO 4 — MATERIALES + RESUMEN ══════════ -->
      <div class="step-panel" *ngIf="currentStep === 4">
        <!-- Contexto del Solicitante Seleccionado -->
        <div class="wizard-location-context" *ngIf="formData.solicitante">
          <div class="wlc-icon-wrap">
            <ion-icon name="person"></ion-icon>
          </div>
          <div class="wlc-text">
            <span class="wlc-label">Solicitado por:</span>
            <span class="wlc-name">{{ formData.solicitante }}</span>
          </div>
        </div>
        <div class="step-header">
          <div class="step-illustration material">
            <ion-icon name="hammer"></ion-icon>
          </div>
          <div class="step-header-text">
            <h2 class="step-question">¿Incluye materiales?</h2>
            <p class="step-hint">Requerimiento de compra de insumos</p>
          </div>
        </div>

        <!-- Toggle de materiales grande -->
        <div class="material-toggle-card" (click)="formData.incluyeMaterial = !formData.incluyeMaterial">
          <div class="mt-icon" [class.active]="formData.incluyeMaterial">
            <ion-icon [name]="formData.incluyeMaterial ? 'construct' : 'construct-outline'"></ion-icon>
          </div>
          <div class="mt-text">
            <span class="mt-label">{{ formData.incluyeMaterial ? 'Sí, incluye materiales' : 'No incluye materiales' }}</span>
            <span class="mt-sub">Toque para cambiar</span>
          </div>
          <!-- Toggle custom CSS -->
          <div class="custom-toggle" [class.on]="formData.incluyeMaterial">
            <div class="toggle-track">
              <div class="toggle-thumb"></div>
            </div>
          </div>
        </div>

        <!-- Resumen compacto de lo seleccionado -->
        <div class="summary-card">
          <div class="summary-title">Resumen de la solicitud</div>
          <div class="summary-row">
            <ion-icon name="person-circle-outline"></ion-icon>
            <span>{{ formData.solicitante }}</span>
          </div>
          <div class="summary-row">
            <ion-icon name="business-outline"></ion-icon>
            <span>{{ formData.cliente }}</span>
          </div>
          <div class="summary-row">
            <ion-icon name="location-outline"></ion-icon>
            <span>{{ formData.direccion }}</span>
          </div>
        </div>
      </div>

    </div>
  </ion-content>

  <!-- ── FOOTER DE ACCIONES ──────────────────────────────────────────── -->
  <div class="wizard-footer">
    <!-- Indicadores de paso (dots) -->
    <div class="step-dots">
      <div class="dot" *ngFor="let i of [1,2,3,4]" [class.active]="i === currentStep" [class.done]="i < currentStep"></div>
    </div>

    <!-- Botones agrupados: Atrás + Continuar/Guardar -->
    <div class="wiz-actions-group">
      <!-- Botón Atrás (visible desde paso 2) -->
      <button class="wiz-prev-btn"
        *ngIf="currentStep > 1"
        (click)="prevStep()">
        <ion-icon name="arrow-back-outline"></ion-icon>
        <span>Atrás</span>
      </button>

      <!-- Botón de avanzar -->
      <button class="wiz-next-btn"
        *ngIf="currentStep < totalSteps"
        [disabled]="!canAdvance()"
        (click)="nextStep()">
        <span>Continuar</span>
        <ion-icon name="arrow-forward-outline"></ion-icon>
      </button>

      <!-- Botón de guardar -->
      <button class="wiz-save-btn"
        *ngIf="currentStep === totalSteps"
        [disabled]="isSaving || !isFormValid()"
        (click)="save()">
        <ion-spinner *ngIf="isSaving" name="crescent"></ion-spinner>
        <ion-icon *ngIf="!isSaving" name="save-outline"></ion-icon>
        <span>{{ isSaving ? 'Guardando...' : 'Guardar' }}</span>
      </button>
    </div>
  </div>

</div>